import React from 'react';

interface IOrLineProps {
  reverseMargin?: number;
}

const OrLine = (props: IOrLineProps) => {
    return (
      <div
        className="OrLineContainer"
        style={{
          marginTop: 60,
          paddingTop: 15,
          border: 0,
          borderTop: 1,
          borderStyle: 'solid',
          borderColor: '#3333334d',
          marginLeft: props.reverseMargin,
          marginRight: props.reverseMargin,
          display: 'flex',
          flexWrap: 'wrap',
        }}>
        <div style={{
          borderRadius: 50,
          backgroundColor: 'white',
          paddingTop: 23,
          width: 56,
          height: 75,
          textAlign: 'center',
          fontSize: 18,
          marginLeft: 'auto',
          marginRight: 'auto',
          marginTop: -53,
          color: '#00000080'
        }}>או
        </div>
      </div>
    )
  }
;
OrLine.defaultProps =
  {
    reverseMargin: 15,
  }
;
export default React.memo(OrLine);
